import React from 'react';
import './Alert.css';

const Alert = ({ title, message, type = 'error', onClose, isVisible = true }) => {
  if (!isVisible || !message) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      case 'error':
      default:
        return 'fas fa-times-circle';
    }
  };

  const getDefaultTitle = () => {
    switch (type) {
      case 'success':
        return 'Éxito';
      case 'warning':
        return 'Advertencia';
      case 'info':
        return 'Información';
      case 'error':
      default:
        return 'Error';
    }
  };

  const resolvedTitle = title || getDefaultTitle();

  return (
    <div className="alert-overlay">
      <div className={`alert-container ${type}`}>
        <div className="alert-content">
          <div className="alert-icon">
            <i className={getIcon()}></i>
          </div>
          <div className="alert-message">
            <h3 className="alert-title">{resolvedTitle}</h3>
            <p className="alert-text">{message}</p>
          </div>
        </div>
        <div className="alert-actions">
          <button className="alert-button" onClick={onClose}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alert;
